export { MindMap as MindMapAnimation } from "./MindMap";
export { OrgChart as OrgChartAnimation } from "./OrgChart";
export { Spreadsheet as SpreadsheetAnimation } from "./Spreadsheet";
export { Whiteboard as WhiteboardAnimation } from "./Whiteboard";
export { Page as PageAnimation } from "./Page";
export { ProjectPlan as ProjectPlanAnimation } from "./ProjectPlan";
export { Wiki as WikiAnimation } from "./Wiki";
